const deleteServiceTypes = {
  toastr: 'Tipo de Serviço deletado',
  toastr1: ' deletado com sucesso'
};

export default deleteServiceTypes;
